import { render, staticRenderFns } from "./remindMessage.vue?vue&type=template&id=6c6a7ca0&scoped=true&"
import script from "./remindMessage.vue?vue&type=script&lang=js&"
export * from "./remindMessage.vue?vue&type=script&lang=js&"
import style0 from "./remindMessage.vue?vue&type=style&index=0&id=6c6a7ca0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a7ca0",
  null
  
)

export default component.exports